<template lang="pug" src='./modal.pug'></template>

<script>
import { closeModal, showModal, moveTo, toggleMenu } from '@/mixins'
import Form from 'components/form/form'
import Icon from 'components/icon/icon'

export default {
  props: [ 'props' ],
  created () {
    console.log(this)
  },
  mixins: [ closeModal, showModal, moveTo, toggleMenu ],
  components: {
    Form,
    Icon
  },
  computed: {
    screenIsMobile () {
      return window.innerWidth < 880
    }
  },
  methods: {
    moveToPayments () {
      console.log('moving to payments')
      console.log(this)
      this.closeModal()
      setTimeout(() => {
        if (this.screenIsMobile) {
          this.$scrollTo('#payments-mobile')
        } else {
          this.$options.parent.$parent.$refs.home.$fullpage.moveTo(6, true)
        }
      }, 350)
    }
  }
}
</script>



// WEBPACK FOOTER //
// modal.vue?a45ad058